<template>

  <div>
    <vehicle-type-edit-info
      :is-edit-vehicle-type-sidebar-active.sync="isEditVehicleTypeSidebarActive"
      :vehicle-type-data="vehicleTypeData"
    />
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-button
                variant="primary"
                @click="isEditVehicleTypeSidebarActive = true"
              >
                <span class="text-nowrap">Add Vehicle Type</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refVehicleTypeListTable"
        class="position-relative"
        :items="vehicleTypes"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              variant="text-danger"
              :to="{ name: 'vehicle-type-walkaround-checks', params: { id: data.item.id } }"
            >
              <span>
                <feather-icon
                  icon="AlertTriangleIcon"
                  class="mr-50"
                />
                    <span>Walkaround Checks</span>
              </span>
            </b-dropdown-item>
            <b-dropdown-item
              variant="text-danger"
              @click="updateVehicleType(data.item)"
            >
              <span>
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                    <span>Edit</span>
              </span>
            </b-dropdown-item>
            <b-dropdown-item
              variant="text-danger"
              @click="deleteVehicleType(data.item.id)"
            >
              <span class="text-danger">
              <feather-icon icon="Trash2Icon" />
              <span class="align-middle ml-50">Delete</span>
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalVehicleTypes"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BButton, BCard, BRow, BCol, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {ref, onUnmounted, onMounted} from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import useVehicleTypeList from "@/views/vehicle-types/useVehicleTypesList";
import vehicleTypeStoreModule from "@/views/vehicle-types/vehicleTypeStoreModule";
import vehicleTypeEditInfo from "@/views/vehicle-types/vehicle-types-edit/VehicleTypeEditInfo";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vehicleTypeEditInfo,

    vSelect,
  },
  methods: {
    updateVehicleType(vehicleType) {
      this.vehicleTypeData = { ...vehicleType }
      this.isEditVehicleTypeSidebarActive = true

    },
    deleteVehicleType(id) {
      store.dispatch('app-vehicle-type/deleteVehicleType', id)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Vehicle type deleted',
              icon: 'CheckSquareIcon',
              variant: 'success',
              text: 'You have successfully deleted this vehicle type.',
            },
          })
          this.isLoading = false
        })
        .catch(err => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Unable to delete vehicle type',
              icon: 'XIcon',
              variant: 'danger',
              text: err.response.data.message || 'An error occurred while deleting this vehicle type.',
            },
          })
          this.isLoading = false
        })
    }
  },
  setup() {
    const VEHICLE_TYPE_APP_STORE_MODULE_NAME = 'app-vehicle-type'

    const vehicleTypeData = ref({})
    // Register module
    if (!store.hasModule(VEHICLE_TYPE_APP_STORE_MODULE_NAME)) store.registerModule(VEHICLE_TYPE_APP_STORE_MODULE_NAME, vehicleTypeStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(VEHICLE_TYPE_APP_STORE_MODULE_NAME)) {
        store.commit(`${VEHICLE_TYPE_APP_STORE_MODULE_NAME}/CLEAR_VEHICLE_TYPES`)
        return store.unregisterModule(VEHICLE_TYPE_APP_STORE_MODULE_NAME)
      }
    })

    onMounted(() => (
      fetchVehicleTypes()
    ));

    const {
      fetchVehicleTypes,
      tableColumns,
      perPage,
      currentPage,
      totalVehicleTypes,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      refVehicleTypeListTable,
      refetchData,
      vehicleTypes

    } = useVehicleTypeList()

    const isEditVehicleTypeSidebarActive = ref(false)

    return {
      fetchVehicleTypes,
      tableColumns,
      perPage,
      currentPage,
      totalVehicleTypes,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      refVehicleTypeListTable,
      refetchData,
      isEditVehicleTypeSidebarActive,
      vehicleTypes,
      // Filter
      avatarText,
      vehicleTypeData,


    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>